import { ReferenceField, TextField } from "ra-ui-materialui";

const LimitField = ({ label, source }) => {
    return (
        <ReferenceField
            label={label}
            source={source}
            reference="chains/chainId/point-rule"
            link={(record) => {
                let resource;

                if (!record.identify) { return null; }

                if (record.identify.startsWith('PO')) {
                    resource = 'point-limit';
                } else if (record.identify.startsWith('NA')) {
                    resource = 'limit-number-fillin';
                } else if (record.identify.startsWith('IN')) {
                    resource = 'point-fillin-interval';
                } else {
                    return null;
                }

                return `/chains/chainId/${resource}/${record.id}/show`;
            }}
            sortable={false}
            emptyText='-'
        >
            <TextField source="identify" />
        </ReferenceField>
    );
};

export default LimitField;